import type {
  CountCompletedMissionsByUserQuery,
  CountCompletedMissionsByUserQueryVariables,
  FetchUserStreakQuery,
  FetchUserStreakQueryVariables,
} from '@edwin-group/cj-graphql/generated/graphql';
import { COUNT_COMPLETED_MISSIONS_BY_USER, QUERY_FETCH_USER_STREAK } from '@edwin-group/cj-graphql';
import { useQuery } from '@apollo/client';
import { CharacterCompassIcon } from './icons/character-compass';
import { MissionsDeliveredIcon } from './icons/missions-delivered';
import { getAuthentication } from '@/hooks/useAuthentication';

export const ProfileStreak = () => {
  const { data: characterCompassData } = useQuery<FetchUserStreakQuery, FetchUserStreakQueryVariables>(
    QUERY_FETCH_USER_STREAK,
    {
      variables: {
        type: 'CHARACTER_COMPASS',
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  const { data: missionsDeliveredData } = useQuery<
    CountCompletedMissionsByUserQuery,
    CountCompletedMissionsByUserQueryVariables
  >(COUNT_COMPLETED_MISSIONS_BY_USER, {
    variables: {
      userDocumentId: getAuthentication().user?.documentId || '',
    },
    fetchPolicy: 'cache-and-network',
  });

  const Box = ({ children }: { children: React.ReactNode }) => {
    return (
      <div className="flex flex-col items-center justify-center gap-1 rounded-3xl border border-[#9FC3FA] p-5 ">
        {children}
      </div>
    );
  };

  return (
    <div className=" mt-sh-60 grid grid-cols-1 gap-sh-15 md:grid-cols-2">
      <Box>
        <CharacterCompassIcon />
        <p className=" text-sh-28-32">{characterCompassData?.fetchUserStreak?.total || 0}</p>
        <p className=" my-0 text-sh-xxs">Character Compass</p>
      </Box>
      <Box>
        <MissionsDeliveredIcon />
        <p className=" text-sh-28-32">{missionsDeliveredData?.countCompletedMissionsByUser || 0}</p>
        <p className=" my-0 text-sh-xxs">Missions delivered</p>
      </Box>
    </div>
  );
};
